import React, { Fragment, useState } from 'react';
import AdminDesignersCalendars from './AdminDesignersCalendars';
import { dayOfWeek2Text, dayOfWeekColor, isToday } from './Utils';
import cn from 'classnames';
import DesignerLine from './DesignerLine';
import MonthSelect from './MonthSelect';
import { getAdminCalendar } from './api/AdminCalendarApi';
import Calendar from './components/Calendar';
import { getStartOfWeek } from './components/Utils';
import { updateDesignerPriority } from './api/AdminDesignersApi';
import AddDesignerPopup from './components/AddDesignerPopup';

export default function AdminCalendar({ calendar, designers: designersInitial, days: daysInitial }) {
  const [designers, setDesigners] = useState(designersInitial);
  const [days, setDays] = useState(daysInitial);
  const [date, setDate] = useState(getStartOfWeek(new Date));
  const [designerCalendar, setDesignerCalendar] = useState(null);
  const [showAddDesignerPopup, setShowAddDesignerPopup] = useState(false);

  const handleDateChange = newDate => {
    setDate(newDate);
    getAdminCalendar(
      calendar,
      newDate,
      data => {
        setDesigners(data.designers);
        setDays(data.days);
      },
      error => console.log(error),
    );
  };

  const closeAddDesignerPopup = () => {
    setShowAddDesignerPopup(false);
    // reload calendar and designers
    handleDateChange(date);
  };

  const handleDesignerClick = designer => {
    setDesignerCalendar(designer);
  };

  const onUpdateDesignerPriority = designer => {
    return priority => {
      updateDesignerPriority(calendar, designer, priority, () => {}, () => {});
      const newDesigners = [...designers];
      const designerToUpdate = newDesigners.find(dsg => dsg.id === designer.id);
      designerToUpdate.priority = priority;
      setDesigners(newDesigners);
    };
  };

  return (
    <Fragment>
      <div className="calendar-header">
        <h2 className='title'>Designers Availability</h2>
        <MonthSelect handleChange={handleDateChange} />
      </div>
      <div className="designer-calendars_wrapper">
        <div className="caledars-panel_left">
          <div key={calendar.id} className="calendar">
            <div className="calendar-days">
              <div className="calendar-add-designer">
                <button type='button' className='btn -empty -y2023' onClick={() => setShowAddDesignerPopup(true)}>Add Designer</button>
              </div>
            </div>
            <div className="calendar-designers">
              {designers.map(designer => (
                <DesignerLine
                  key={`designer-${designer.id}`}
                  designer={designer}
                  updateDesignerPriority={onUpdateDesignerPriority(designer)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="calendar-panel_right">
          <div key={calendar.id} className="calendar">
            <div className="calendar-days">
              {days.map(day => (
                <div key={`${day.day}${day.dom}${day.year}`} className={cn('calendar-day', '-header', dayOfWeekColor(day.dow), {'-today': isToday(day)})} >
                  <div className="total">
                    <span className={cn({'highlight': day.total.slots})}>{day.total.booked}</span>
                    <span>{` / ${day.total.slots}`}</span>
                  </div>
                  <div className="dow">{dayOfWeek2Text(day.dow)}</div>
                  <div className="day">{day.dom}</div>
                  {/*<div className="month">{month2Text(day.month)}</div>*/}
                </div>
              ))}
            </div>
            <div className="calendar-designers">
              {designers.map(designer => (
                <AdminDesignersCalendars key={designer.id} designer={designer} handleDesignerClick={handleDesignerClick} days={days} selected={designerCalendar && designer && designer.id == designerCalendar.id} />
              ))}
            </div>
          </div>
        </div>
      </div>
      {designerCalendar && (
        <Fragment>
          <Calendar admin={true} calendar={calendar} designer={designerCalendar} date={date} name={designerCalendar.full_name} availabilityUrl={designerCalendar.availability_url} />
        </Fragment>
      )}
      {showAddDesignerPopup && (
        <AddDesignerPopup designers={designers} calendar={calendar} onCloseModal={closeAddDesignerPopup} />
      )}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/index.js